import React from "react";
import SectionTitle from "../components/SectionTitle";
import Seo from "../components/Seo";
import { CalendarDays } from "lucide-react";
import { useData } from "../context/DataContext";

const DatesImportantes = () => {
  const { dates, settings, loaded } = useData();
  if (!loaded) return <div className="min-h-[60vh] flex items-center justify-center text-stone-500">Chargement...</div>;
  const SITE = settings || {};

  return (
    <>
      <Seo title={`Dates importantes saison ${SITE.season} — L'Élan Danse`} description="Les dates clés de la saison de l'école de danse L'Élan Danse : rentrée, vacances, spectacles, portes ouvertes." />
      <section className="py-20 px-6">
        <SectionTitle kicker={`Saison ${SITE.season || ""}`} title="Dates importantes" subtitle="Tous les rendez-vous à ne pas manquer cette année." />
        <div className="max-w-3xl mx-auto space-y-4">
          {dates.map((d, i) => (
            <div key={d.id || i} className="bg-white rounded-2xl shadow-sm p-6 flex items-center gap-5 hover:shadow-md transition-shadow">
              <div className="shrink-0 w-14 h-14 rounded-full bg-blush flex items-center justify-center text-deep-rose">
                <CalendarDays />
              </div>
              <div>
                <h3 className="font-serif-display text-xl text-stone-800">{d.label}</h3>
                <p className="text-deep-rose font-serif-display">{d.value}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default DatesImportantes;
